export const setUserId = (id) => {
  localStorage.setItem("userUserId", id);
};
export const getUserId = () => {
  return localStorage.getItem("userUserId");
};

export const setUserGymData = (data) => {
  return localStorage.setItem("userGymData", data);
};

export const getUserGymData = () => {
  let temp = localStorage.getItem("userGymData");
  return temp ? JSON.parse(temp) : null;
};

export const removeGym = () => {
  localStorage.setItem("userGymId", "");
};

export const manageSubscription = (value) => {
  localStorage.setItem("showSubscriptionEnded", value);
};
export const manageTrail = (value) => {
  localStorage.setItem("showTrailBar", value);
};
export const getSubscription = () => {
  return localStorage.getItem("showSubscriptionEnded");
};
export const getTrail =()=>{
  return localStorage.getItem("showTrailBar");
}

export const setIsMessageUnseen = (value) => {
  return localStorage.setItem("isMessageUnseen", value);
};

export const getIsMessageUnseen = () => {
  return localStorage.getItem("isMessageUnseen");
};

export const setIsNonMessageUnseen = (value) => {
  return localStorage.setItem("isNonMessageUnseen", value);
};

export const getIsNonMessageUnseen = () => {
  return localStorage.getItem("isNonMessageUnseen");
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
